import React from 'react';
import { TypographyStyled } from '../../asset/styled/component/TypographyStyled';

const Typography = ({
  children,
  color,
  size,
  weight,
  fontFamily,
  lineHeight,
  textAlign,
  ...props
}) => {
  // HTML 엔티티 &nbsp;를 실제 공백 문자로 변환
  const processedChildren = React.useMemo(() => {
    if (typeof children === 'string') {
      return children.replace(/&nbsp;/g, ' '); // 일반 공백으로 변환
      // 또는 아래처럼 사용할 수 있습니다
      // return children.replace(/&nbsp;/g, '\u00A0');  // 줄바꿈이 안되는 공백으로 변환
    }
    return children;
  }, [children]);

  return (
    <TypographyStyled
      color={color}
      size={size}
      weight={weight}
      fontFamily={fontFamily}
      lineHeight={lineHeight}
      textAlign={textAlign}
      {...props}>
      {processedChildren}
    </TypographyStyled>
  );
};

export default Typography;
